<template>
  <div class="default-layout">
    <Sidebar :open="sidebarOpen"
      @close-menu="closeMenu"
    />
    <div class="wrap" :style="wrapStyle">
        <nav class="sidebar-toggle-wrapper">
        <a href="javscript:void(0)" @click.prevent="toggleMenu" data-test-ref="navMenuLink">
          <div class="sidebar-toggle" :class="`${sidebarOpen ? 'active' : null}`">
              <svg v-if="!sidebarOpen" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="34px" height="27px" viewBox="0 0 34 27" enable-background="new 0 0 34 27" xml:space="preserve" transform="scale(.8)">
                <rect fill="#FFFFFF" width="34" height="4"/>
                <rect y="11" fill="#FFFFFF" width="34" height="4"/>
                <rect y="23" fill="#FFFFFF" width="34" height="4"/>
              </svg>
              <span>×</span>
            </label>
          </div>
        </a>
      </nav>
      <slot />
    </div>
    <v-dialog/>
  </div>
</template>

<script>
import Sidebar from '../components/Sidebar.vue'

export default {
  name: 'DefaultLayout',
  data() {
    return {
      sidebarOpen : false
    }
  },
  computed : {
    wrapStyle() {
      return this.sidebarOpen ?
        { left : "14rem" }
        : null
    }
  },
  methods : {
    openMenu() {
      this.sidebarOpen = true
    },
    closeMenu() {
      this.sidebarOpen = false
    },
    toggleMenu () {
      if (this.sidebarOpen) {
        this.closeMenu()
      } else {
        this.openMenu()
      }
    }
  },
  components : {
    Sidebar
  }
}
</script>
<style lang="scss">

@import '@/assets/scss/variables.scss';
@import '@/assets/scss/base.scss';
@import '@/assets/scss/layout.scss';
@import '@/assets/scss/typebase.scss';


.sidebar-toggle {
  background-color: $primary-color;
  position: sticky;
  top: -.5em;
  left: 0;
  display: block;
  width: 60px;
  height: 60px;
  border-radius: 0 0 80px 0;
  padding: .5rem .65rem;

  cursor: pointer;
  svg {
    margin: .8em 0 0 .5em;
  }
  &>span{
    display:none;
  }
}

.sidebar-toggle.active {
  background-color: $primary-color;
  color: #fff;
  svg {
    display:none;
  }

  span{
    display:block;
    margin: .2em 0 0 .2em;
    font-size:40px;
    line-height:40px;
  }
}

@media (min-width: 30.1rem) {
  .sidebar-toggle {
    position: sticky;
  }
  .sidebar-toggle:before {
    padding-bottom: .15rem;
    border-top-width: .45rem;
    border-bottom-width: .15rem;
  }
}

.container {
  width: 85%;
  margin: 0 auto;
}

button {
  padding: 10px;
  font-size: 1.2em;
  background-color: steelblue;
  color: white;
  border: none;
  border-radius: 5px;
  cursor:pointer;
  margin: 5px 10px
}
</style>
